import React from "react";

import Brand from "assets/img/Group 157.svg";
import Report from "assets/img/Group 161.svg";
import Design from "assets/img/Group 159.svg";
import Digital from "assets/img/Group 158.svg";
import Research from "assets/img/Group 156.svg";
import Implement from "assets/img/Group 160.svg";

import "./discuss-section.styles.scss";

export const DiscussSection = () => {
  return (
    <div className="discuss-section">
      <div className="container discuss-section_header m-auto text-center">
        <h6>The Process</h6>
        <h3 className="mt-3">
          Get your desired digital <br />
          experience efficiently
        </h3>
      </div>

      <div className="container">
        <div className="discuss-section_images">
          <div className="d-flex justify-content-between flex-wrap">
            <img src={Research} alt="research"></img>
            <img src={Brand} alt="brand"></img>
            <img src={Digital} alt="digital"></img>
            <img src={Design} alt="design"></img>
            <img src={Implement} alt="implement"></img>
            <img src={Report} alt="reporting"></img>
          </div>
        </div>

        <div className="discuss-section_button">
          <div>
            <h1>Do you have a project to discuss?</h1>
            <p>Let us help you setup your brand digitally.</p>
          </div>

          <button className="btn btn-lg btn-rounded d-none d-lg-block">
            Get a Quote
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscussSection;
